import React from 'react';
import { Icon } from 'office-ui-fabric-react';

import { Props } from './MenuButton.types';
import { Styled } from './MenuButton.styles';

export const MenuButton: React.FC<Props> = ({ children, onClick }) => {
  return (
    <Styled.MenuButton onClick={onClick}>
      {children}
      <Icon iconName="ChevronRight" />
    </Styled.MenuButton>
  );
};
